import Vue from 'vue';
import VueGoogleMaps, { Autocomplete } from '@fawmi/vue-google-maps'
import { getEnvVar } from '@utils';

const GOOGLE_API_KEY = getEnvVar('GOOGLE_API_KEY'); // Ensure the environment variable is set.

let isGoogleMapsInitialized = false; // Flag to indicate whether Google Maps has been initialized

// Function to initialize Google Maps only once and return a Promise
export default function initializeGoogleMaps() {
  if (!isGoogleMapsInitialized) {
    Vue.use(VueGoogleMaps, {
      load: {
        key: GOOGLE_API_KEY,
        libraries: 'places', // necessary for places input
      },
    });
    Vue.component('GMapAutocomplete', Autocomplete);

    isGoogleMapsInitialized = true; // Set the flag to true after initialization
  }
}
